var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{class:_vm.mutableToggle ? 'collapseDrawer' : ''},[_c('span',{staticClass:"nav-toggler-icon",on:{"click":_vm.toggleSideBar}},[_c('i',{class:_vm.mutableToggle
          ? 'fas fa-arrow-alt-circle-left rotate'
          : 'fas fa-arrow-alt-circle-left'})]),_c('div',[_c('div',{staticClass:"d-flex justify-content-center mb-3 mt-5 section-title"},[_c('h2',[_vm._v(_vm._s(_vm.header))])]),_c('main',[_vm._t("body",null,{"toggle":_vm.toggleSideBar})],2)]),_c('footer',[_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }